module.exports = __webpack_public_path__ + "static/img/jzlogo.fef5ad2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jzlogo.png
// module id = SEhG
// module chunks = 1